/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DrugbankRegions
 */
export interface DrugbankRegions {
    /**
     * 
     * @type {boolean}
     * @memberof DrugbankRegions
     */
    us?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DrugbankRegions
     */
    canada?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DrugbankRegions
     */
    eu?: boolean;
}

/**
 * Check if a given object implements the DrugbankRegions interface.
 */
export function instanceOfDrugbankRegions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DrugbankRegionsFromJSON(json: any): DrugbankRegions {
    return DrugbankRegionsFromJSONTyped(json, false);
}

export function DrugbankRegionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DrugbankRegions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'us': !exists(json, 'us') ? undefined : json['us'],
        'canada': !exists(json, 'canada') ? undefined : json['canada'],
        'eu': !exists(json, 'eu') ? undefined : json['eu'],
    };
}

export function DrugbankRegionsToJSON(value?: DrugbankRegions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'us': value.us,
        'canada': value.canada,
        'eu': value.eu,
    };
}

